import React, { forwardRef, RefObject } from 'react';
import classNames from 'classnames';

import { StyledMenuButtonContentFooter } from './styles';
import { MenuButtonContentFooterProps } from './types';
import { Comp, getContainerStylingTransientProps } from '@redsift/design-system';

const COMPONENT_NAME = 'MenuButtonContentFooter';
const CLASSNAME = 'redsift-combobox-content-footer';

/**
 * The MenuButtonContentFooter component.
 */
export const MenuButtonContentFooter: Comp<MenuButtonContentFooterProps, HTMLDivElement> = forwardRef((props, ref) => {
  const { transientProps, otherProps } = getContainerStylingTransientProps(props);

  const { children, className, ...forwardedProps } = otherProps;

  return (
    <StyledMenuButtonContentFooter
      {...forwardedProps}
      {...transientProps}
      className={classNames(MenuButtonContentFooter.className, className)}
      ref={ref as RefObject<HTMLDivElement>}
    >
      {children}
    </StyledMenuButtonContentFooter>
  );
});
MenuButtonContentFooter.className = CLASSNAME;
MenuButtonContentFooter.displayName = COMPONENT_NAME;
